export const SubscriptionDurationEnum = Object.freeze({
	MONTH: "month",
	YEAR: "year",
	LIFETIME: "lifetime",
})
